//todo We should handle these in translation files. This is a temporary solution

import { Instruction } from "types/testTypes";

export const dyslexiaInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- Please inform the patient to press the trigger button when ready to start calibration.",
    "- The patient should focus on the circle and press the trigger button as instructed.",
    "- Inform the patient that after calibration, a countdown from 3 will appear, followed by a text. The patient should read the text and press the trigger button when they finish reading.",
    "- The operator can also press the 'Finish' button on the webpage to end the test.",
  ],
};

export const readingAssessmentInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- Please inform the patient to press the trigger button when ready to start calibration.",
    "- The patient should focus on the circle and press the trigger button as instructed.",
    "- Inform the patient that after calibration, a countdown from 3 will appear, followed by a text. The patient should read the text and press the trigger button when they finish reading.",
    "- The operator can also press the 'Finish' button on the webpage to end the test.",
  ],
};

export const cptInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- Please inform the patient to press the trigger button when ready to start calibration.",
    "- The patient should focus on the circle and press the trigger button as instructed.",
    "- Inform the patient that after calibration, the test will begin when they press the trigger button.",
    "- The patient should only press the trigger button when the target appears on the screen and not at any other time.",
    "- If the patient reports that the scene is not aligned correctly, press and hold the Home button for 3 seconds to realign the view.",
  ],
};

export const ascendingInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "Please inform the patient to press the trigger button when ready. " +
      "The test will start automatically and a high contrast circle will appear for each gratings type as example.",
    "After this circle disappers, a second one will appear with zero contrast. " +
      "Inform patient to press the trigger button when they start to identify the gratings on the circle.",
  ],
};

export const thresholdInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "Please inform the patient to press the trigger button when ready. " +
      "The test will start automatically and circles with different contrast values will start to appear.",
    "Inform patient to only press the trigger button when they can identify the gratings on the circle." +
      "The patient should not press the trigger button if they can't identify the gratings.",
  ],
};

export const pupillometryInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "Please inform the patient to look at the the target at the center and press the trigger button when ready.",
    "The test will start automatically and the patient should keep looking at the target until the test is finished.",
    "There will be bright flashes of light during the test, please inform the patient to try to keep their eyes open.",
  ],
};

export const ocularMotilityInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "Please inform the patient to look at the the target at the center and press the trigger button when ready.",
    "After the target starts moving, the patient should follow the target with their eyes.",
  ],
};

export const coverInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "Please inform the patient to press the trigger button when ready.",
    "After pressing the button, the patient should simply look at what is shown on the screen.",
  ],
};

export const stereoAcuityInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "The patient should point and press the trigger on the target that they think is closest to them.",
    "The test will start automatically after the patient presses the trigger button.",
  ],
};

export const videonystagmographyInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "Please inform the patient to look at the the target at the center and press the trigger button when ready.",
    "The test will start automatically and the patient should keep looking at the target until the test is finished.",
  ],
};

export const optokineticNystagmusInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "Please inform the patient to press the trigger button when ready.",
    "The patient should look naturally at the moving stars and pay attention to them until the test is finished.",
  ],
};

export const colorVisionInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- Look carefully at each pattern and say aloud the number or shape you see inside it.",
    "- If you do not see anything, clearly say “nothing” to the operator.",
    "- In some cases, the operator may ask you specific questions — please answer them aloud.",
  ],
};

export const amslerGridInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- Focus on the dot in the center of the grid and keep your gaze fixed on it.",
    "- While looking at the center, note if any lines appear wavy, blurry, or missing.",
    "- Describe aloud to the operator anything unusual you notice about the lines or shapes.",
  ],
};

export const visualAcuityInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- The operator will guide you to start reading from the top line of letters and then continue line by line in order.",
    "- Read aloud the letters on each line as you are directed.",
    "- Continue until the letters become too difficult to identify, and clearly tell the operator what you see.",
  ],
};

export const fdtInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- Keep your eyes focused on the center of the screen at all times during the test.",
    "- Press the trigger button once to start the test when you are ready and looking at the center.",
    "- Continue pressing the trigger button whenever you see a flickering pattern appear.",
  ],
};

export const kineticPerimetryInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- Keep your eyes focused on the center point at all times during the test.",
    "- Press the trigger button once to start the test when you are ready and looking at the center.",
    "- Press the trigger button whenever you detect the moving stimulus in your peripheral vision.",
    "- Try to respond as quickly as possible when you see the stimulus.",
  ],
};

export const wcstInstruction: Instruction = {
  title: "Instructions for the Patient",
  description: [
    "- Please inform the patient to press the trigger button when ready to start the test.",
    "- The patient will see a reference card and several response cards. They should select the card that matches the reference card using the controller.",
    "- The matching rule (by color, shape, or number) may change during the test without warning. The patient should try to discover the correct rule from the feedback given after each selection.",
    "- The operator can press the 'Finish' button on the webpage to end the test early if needed.",
  ],
};
